export const appFilters = {
    categories: {
        name: "categories",
        list: [],
        match: (application, value, locale) => {
            return application.categories.findIndex(item => item[locale] === value) >= 0;
        },
    },
    author: {
        name: "author",
        list: [],
        match: (application, value) => {
            return application.author === value;
        },
    },
    warehouseId: {
        name: "warehouseId",
        list: [],
        match: (application, value, locale) => {
            return application.warehouseId === value;
        },
    },
    type: {
        name: "type",
        list: [],
        match: (application, value) => {
            return application.type === value;
        },
    },
    executionEnvironment: {
        name: "executionEnvironment",
        list: [],
        match: (application, value) => {
            return application.executionEnvironment === value;
        },
    },
    executionContext: {
        name: "executionContext",
        list: [],
        match: (application, value) => {
            return application.executionContext.indexOf(value) >= 0;
        },
    },
};
